import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { Card } from '../components/Card';
import { Text } from '../components/Text';

export const ResourcesCard: FC = () => {
    const mixpanel = useInstance(MixPanelEventEmitter);

    return (
        <Card padded>
            <div style={{marginBottom: 12}}>
                <Text><b>Caregiver Resources</b></Text>
            </div>

            <p>
                <Text type="detail">Find Innerhive-curated resources: Community Support Groups, Services, and much more!</Text>
            </p>

            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center'}}>
                <IonButton
                    expand="block"
                    href="https://www.innerhive.com/caregiver-resources/all-resources"
                    target="_blank"
                    onClick={() => mixpanel.track('Caregiver Resources Opened')}
                >
                    Find Resources
                </IonButton>
            </div>

            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center'}}>
                <IonButton
                    fill="outline"
                    expand="block"
                    href="https://m.facebook.com/groups/1042454824128374/?ref=share&mibextid=S66gvF"
                    target="_blank"
                    onClick={() => mixpanel.track(`Caregiver's FB Group Opened`)}
                >
                    Join Innerhive's Caregiver Group
                </IonButton>
            </div>
        </Card>
    );
};
